import { asyncHandler } from '../../async-handler';
import store from '../../../../store/store';
import { RequestInfo } from '../../../../interfaces/RequestInfo';
import { USER_CHANNELS_API } from '../../../constants/central-api';

const POLICY_REFUSAL_MESSAGE = 'This action is unauthorized.';

export default async function get_communication_channels_api_call() {
  const userID = store.getState().user.profile?.user_id;
  // An employee-only session has no seller user id; never request
  // /users//channels. Report it as a refusal so the page shows its notice.
  if (!userID) {
    throw Object.assign(new Error('no seller user id'), { status: 403 });
  }
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  const requestInfo: RequestInfo = {
    url: USER_CHANNELS_API(userID),
    method: 'GET',
    headers: {
      Accept: 'application/json',
      // 'Content-type': 'application/x-www-form-urlencoded',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'GET_USER_CHANNELS';
  const customMsg = 'User channels fetched successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );
  const response = res?.data;

  if (res?.actionType === actionType && response?.success === true) {
    return response?.data || [];
  }
  // A member who may not read these channels gets 401/403, or a 400 whose
  // message is exactly the policy refusal. Throw it marked as 403 so the page
  // shows its no-access message; any other 400 keeps its own error.
  const status = Number(res?.responseStatus);
  const message = typeof response?.message === 'string' ? response.message : '';
  if (
    status === 401 ||
    status === 403 ||
    (status === 400 && message.trim() === POLICY_REFUSAL_MESSAGE)
  ) {
    throw Object.assign(new Error(message || 'forbidden'), { status: 403 });
  }
  return [];
}
